import React from "react";

import { SkeletonText } from "~/components/skeleton/text";

import { useNavigateToLink } from "../../../components/react/link";
import { DASHBOARDS_OVERVIEW_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

export interface DashboardMenuOverviewItemProps {
	dashboardsCount: undefined | number;
}

export const DashboardMenuOverviewItem: React.FC<DashboardMenuOverviewItemProps> = ({ dashboardsCount }) => {
	const link = useNavigateToLink(DASHBOARDS_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			icon={
				<SkeletonText
					className="skeleton:w-full max-w-[18px] font-medium text-10 text-graphite-600 leading-3"
					el="span"
					when={dashboardsCount}
				/>
			}
			label={<SkeletonText when={dashboardsCount}>{() => "All dashboards"}</SkeletonText>}
			level={1}
			to={dashboardsCount == null ? undefined : link}
		/>
	);
};
